import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import ProfileSelector from '../../selectors/profileSelector'
import { Button } from '@sketchpixy/rubix'

const UserAccountShow = ({ userProfile: { email, username, phone_number } }) => (
  <div id="user-profile-show">
    <section>
      <section>
        <strong>نام کاربری</strong>
        <span>{username}</span>
      </section>

      <section>
        <strong>ایمیل</strong>
        <span>{email}</span>
      </section>

      <section>
        <strong>شماره موبایل</strong>
        <span>{phone_number}</span>
      </section>
    </section>

    <section>
      <Button onClick={() => browserHistory.push('/dashboard/account/email-change')}>
        تغییر ایمیل و شماره موبایل
      </Button>

      <Button onClick={() => browserHistory.push('/dashboard/account/password-change')}>
        تغییر گذرواژه
      </Button>
    </section>
  </div>
)

export default connect(ProfileSelector)(UserAccountShow)



// WEBPACK FOOTER //
// ./src/components/dashboard/UserAccountShow.js